export default "__VITE_ASSET__DhjHXoOS__"